import { render, staticRenderFns } from "./AdminComponent.vue?vue&type=template&id=0f5b02a6&scoped=true"
import script from "./AdminComponent.vue?vue&type=script&lang=js"
export * from "./AdminComponent.vue?vue&type=script&lang=js"
import style0 from "./AdminComponent.vue?vue&type=style&index=0&id=0f5b02a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5b02a6",
  null
  
)

export default component.exports